import vue from "../main";

export const insuranceTypeID = Object.freeze({
  INSURANCE_ASK: 2,
  INSURANCE_ADD: 1,
  INSURANCE_NO: 3
});

export const insuranceOptions = () => {
  return [
    { text: vue.$t("travelService.insuranceAsk"), value: insuranceTypeID.INSURANCE_ASK },
    { text: vue.$t("travelService.insuranceAdd"), value: insuranceTypeID.INSURANCE_ADD },
    { text: vue.$t("travelService.insuranceNo"), value: insuranceTypeID.INSURANCE_NO }
  ];
};

export const changeAcceptanceType = Object.freeze({
  INFORM_AFTER_CHANGE: 1,
  ACCEPTANCE_NEEDED: 2
});

export const changeAcceptanceOptions = () => {
  return [
    { text: vue.$t("travelService.changesAcceptanceType.inform"), value: changeAcceptanceType.INFORM_AFTER_CHANGE },
    { text: vue.$t("travelService.changesAcceptanceType.acceptanceNeeded"), value: changeAcceptanceType.ACCEPTANCE_NEEDED }
  ];
};

export const allRoomTypes = () => {
  return [
    {
      text: vue.$t("travelService.roomTypes.single"),
      value: "single",
      capacity: 1
    },
    {
      text: vue.$t("travelService.roomTypes.twin"),
      value: "twin",
      capacity: 2
    },
    {
      text: vue.$t("travelService.roomTypes.double"),
      value: "double",
      capacity: 2
    },
    {
      text: vue.$t("travelService.roomTypes.three"),
      value: "three",
      capacity: 3
    },
    {
      text: vue.$t("travelService.roomTypes.four"),
      value: "four",
      capacity: 4
    },
    {
      text: vue.$t("travelService.roomTypes.more"),
      value: "more",
      capacity: null
    }
  ];
};

export const allCarTypes = () => {
  return [
    { text: vue.$t("travelService.any"), value: "-" },
    {
      text: "Segment A (" + vue.$t("travelService.carTypes.a") + ")",
      value: "A"
    },
    {
      text: "Segment B (" + vue.$t("travelService.carTypes.b") + ")",
      value: "B"
    },
    {
      text: "Segment C (" + vue.$t("travelService.carTypes.c") + ")",
      value: "C"
    },
    {
      text: "Segment D (" + vue.$t("travelService.carTypes.d") + ")",
      value: "D"
    },
    {
      text: "Segment E (" + vue.$t("travelService.carTypes.e") + ")",
      value: "E"
    },
    {
      text: "Segment F (" + vue.$t("travelService.carTypes.f") + ")",
      value: "F"
    },
    {
      text: "Segment G (" + vue.$t("travelService.carTypes.g") + ")",
      value: "G"
    },
    {
      text: "Segment H (" + vue.$t("travelService.carTypes.h") + ")",
      value: "H"
    },
    {
      text: "Segment I (" + vue.$t("travelService.carTypes.i") + ")",
      value: "I"
    },
    {
      text: "Segment K (" + vue.$t("travelService.carTypes.k") + ")",
      value: "K"
    }
  ];
};

export const allRailClassTypes = () => {
  return [
    { text: vue.$t("travelService.firstClass"), value: "first" },
    { text: vue.$t("travelService.secondClass"), value: "second" },
    { text: "Business", value: "business" },
    { text: "Economy", value: "economy" }
  ];
};

export const allFlightClassTypes = () => {
  return [
    { text: vue.$t("travelService.firstClass"), value: "first" },
    { text: "Premium", value: "premium" },
    { text: "Business", value: "business" },
    { text: "Economy", value: "economy" },
    { text: vue.$t("travelService.lowCost"), value: "low_cost" }
  ];
};
